import { render, staticRenderFns } from "./obyomdvigatel.vue?vue&type=template&id=aac7e86c&scoped=true&"
import script from "./obyomdvigatel.vue?vue&type=script&lang=js&"
export * from "./obyomdvigatel.vue?vue&type=script&lang=js&"
import style0 from "./obyomdvigatel.vue?vue&type=style&index=0&id=aac7e86c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aac7e86c",
  null
  
)

export default component.exports